<template>
  <div>
    <div class="statuses-block">
      <div class="status-block">
        <div class="dot active-status"></div>
        <div class="status-name">{{ 'Active' | i18n }}</div>
      </div>
      <div class="status-block">
        <div class="dot inprogress-status"></div>
        <div class="status-name">{{ 'In Progress' | i18n }}</div>
      </div>
      <div class="status-block">
        <div class="dot finished-status"></div>
        <div class="status-name">{{ 'Finished' | i18n }}</div>
      </div>
    </div>
    <Table
      :update="loadCases"
      :columns="columns"
      :rows="cases"
      :filter="filter"
      :update-filter="updateFilter"
      :loading-instance="loadingInstance"
      :set-loading-instance="setLoadingInstance"
      tableName="administrationCasesTable"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { ReportsMixin, NotificationMixin, DeleteRowMixin } from '../../../../../mixins';
import { CASE_STATUSES } from '../../../../../../../../constants';
import Table from '../../../common/table';

export default {
  name: 'Reports',
  components: { Table },
  mixins: [ReportsMixin, NotificationMixin, DeleteRowMixin],
  props: {
    getCases: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      cases: [],
      loadingInstance: null,
      filter: {
        page: 1,
        limit: 10,
        totalCount: 0,
        sortBy: 'updatedAt',
        sortOrder: 'desc',
      },
      columns: [
        {
          field: 'status',
          title: '',
          key: '1',
          width: 15,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const cellData = row[column.field];
            const color = (() => {
              switch (cellData) {
                case CASE_STATUSES.ACTIVE:
                  return 'active';
                case CASE_STATUSES.IN_PROGRESS:
                  return 'inprogress';
                case CASE_STATUSES.FINISHED:
                  return 'finished';
              }
            })();
            return <div class={`status-cell ${color}-status`}></div>;
          },
        },
        {
          field: 'caseNumber',
          title: '#',
          width: 100,
          key: '2',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }, h) => row.caseNumberString,
        },
        {
          field: 'teamName',
          title: this.$translate('team'),
          key: '3',
          align: 'left',
        },
        {
          field: 'title',
          title: this.$translate('title'),
          key: '4',
          align: 'left',
        },
        {
          field: 'templateTitle',
          title: this.$translate('template'),
          key: '5',
          align: 'left',
        },
        {
          field: 'userName',
          title: this.$translate('Assigned User'),
          key: '6',
          width: 200,
        },
        {
          field: 'createdAt',
          title: this.$translate('Date Created'),
          key: '7',
          sortBy: 'desc',
          width: 200,
        },
        {
          field: 'details',
          title: '',
          key: '8',
          width: 400,
          renderBodyCell: ({ row }, h) => {
            return (
              <div class="download-buttons">
                <div class="download-button" on-click={() => this.restoreCase(row.id)}>
                  {this.$translate('Restore case')}
                </div>
                <div class="download-button delete-button" on-click={() => this.hardDelete(row.id)}>
                  {this.$translate('Permanently delete')}
                </div>
              </div>
            );
          },
        },
      ],
    };
  },
  methods: {
    async loadCases() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
        };
        const response = await this.getCases(ctx);
        response.data = response.data.map((item) => ({
          ...item,
          teamName: item.team.name,
          createdAt: moment(item.createdAt).format('DD.MM.YY HH:mm'),
          templateTitle: item.template.name,
          userName: item.user.name,
        }));
        this.filter.totalCount = response.totalCount;
        this.stopLoading();
        this.cases = response.data;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    async restoreCase(id) {
      try {
        this.startLoading();
        await this.reportsService.restoreCase(id);
        this.loadCases();
        this.showNotification({ type: 'success', title: this.$translate('success'), message: this.$translate('success') });
      } catch (err) {
        this.stopLoading();
        this.showNotification({ type: 'error', message: err.message });
      }
    },
    async hardDelete(id) {
      await this.deleteSelectedRows(null, async () => {
        try {
          this.startLoading();
          await this.reportsService.hardDeleteCase(id);
          this.loadCases();
        } catch (err) {
          this.stopLoading();
          this.showNotification({ type: 'error', message: err.message });
        }
      });
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.img-wrapper {
  padding-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-preview {
  width: 100%;
  box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.21);
}

::v-deep .download-buttons {
  display: flex;
  justify-content: space-around;
}
::v-deep .download-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  cursor: pointer;
}

::v-deep .status-cell {
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  border-radius: 0 2px 2px 0;
}

::v-deep .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
::v-deep .active-status {
  background-color: rgb(37, 154, 43);
}
::v-deep .inprogress-status {
  background-color: rgb(239, 255, 15);
}
::v-deep .finished-status {
  background-color: rgb(90, 98, 107);
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  width: 100%;
}

.status-block {
  display: flex;
  margin-left: 20px;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.status-name {
  margin-left: 10px;
}

::v-deep .delete-button {
  border-color: #db474f;
  background: rgb(219, 71, 79);
  color: white;
}
</style>
